import React, { Component } from 'react'
import styled from 'styled-components'
import { Icon } from './'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  padding: ${props => props.viewPadding || '0px'};
  padding-top: ${props => (props.paddingTop ? props.paddingTop : '90px')};
`
const StyledInput = styled.textarea`
  height: ${props => (props.height ? props.height : 'auto')};
  max-height: ${props => (props.maxHeight ? props.maxHeight : 'none')};
  width: 100%;
  border: none;
  border-bottom: ${props => (props.borderBottom ? props.borderBottom : 'solid 1px #b7c3bf')};
  font-size: 15px;
  line-height: 1.2;
  letter-spacing: normal;
  background: ${props => (props.background ? props.background : 'transparent')};
  border-radius: ${props => (props.borderRadius ? props.borderRadius : '0')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  color: #124b5f;
  outline: none;
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #124b5f;
    opacity: 1; /* Firefox */
    font-family: 'Overpass', sans-serif !important;
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #124b5f;
    font-family: 'Overpass', sans-serif !important;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #124b5f;
    font-family: 'Overpass', sans-serif !important;
  }
  ::-webkit-scrollbar {
    width: 2px; /* remove scrollbar space */
    background: transparent; /* optional: just make scrollbar invisible */
  }
  resize: none;
  opacity: ${props => (props.readOnly ? 0.5 : 1)};
  cursor: ${props => (props.readOnly ? 'not-allowed' : 'pointer')};
`
class TextArea extends Component {
  render() {
    const { icon, fill, error, readOnly, background, paddingTop, viewPadding, height, ...props } = this.props
    return (
      <Wrapper paddingTop={paddingTop} viewPadding={viewPadding}>
        {icon && <Icon icon={icon} fill={fill} />}
        <StyledInput background={background} readOnly={readOnly} height={height} {...props} />
      </Wrapper>
    )
  }
}
export default TextArea



// WEBPACK FOOTER //
// ./src/components/TextArea.js